import styles from './ArticleList.module.scss';
import { Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import { PreviewCardList } from 'ui/components/3-organisms/PreviewCardList/PreviewCardList';
import ColorOptions, { LinkType } from 'helpers/types';
import classNames from 'classnames';
import { Container } from 'ui/components/4-habitats/Container/Container';

export interface ArticleListProps {
	rootFolderId?: number;
	count?: number;
	offset?: number;
	buttonText?: string;
	bgColor?: ColorOptions;
	filter?: string;
	link?: LinkType;
	articleFetcher: (
		rootId: number,
		limit: number,
		offset: number,
		filter?: string,
	) => {
		articles?: PreviewCardProps[];
		isLoading: boolean;
	};
}

export const ArticleList: React.FC<ArticleListProps> = ({ rootFolderId, count, offset, buttonText, bgColor, filter, articleFetcher }) => {
	const rootId = rootFolderId ? rootFolderId : 0;
	const limitQuery = count === 0 ? null : count;
	const offsetQuery = offset >= 0 ? offset : null;
	const articleResult = articleFetcher(rootId, limitQuery, offsetQuery);

	if (articleResult.isLoading) return <Spinner style="large" />;
	if (!articleResult.articles) return <></>;

	return (
		<div className={classNames(styles.ArticleList_cards, styles[`u-color___${bgColor}`])}>
			<Container width="Standard">
				<PreviewCardList items={articleResult.articles} desktopWidth="100" mobileWidth="100" buttonText={buttonText} />
			</Container>
		</div>
	);
};
